import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

// THE SOLUTION PAGER (CR-20260830-002). The backend returns up to TWO RANKED SOLUTIONS (plus
// rare flagged torn variants); this strip slides between them ("‹ 1 of 2 ›") and nothing more -
// no page label (owner ruling 2026-09-03: paginator only; the earlier 'Leanest' / 'Best shape'
// and then 'Best' / 'Next best' words are gone). One page -> the strip renders nothing at all -
// the single answer needs no pager. Shared by the Order Verification Dialog's preview pane and
// the Re-group dialog's zones column.
@Component({
    selector: 'ets-ooa-solution-pager',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="ooa-pager" *ngIf="this.count > 1">
            <dx-button icon="chevronleft"
                       [disabled]="this.index <= 0"
                       (onClick)="this.step(-1)"
                       hint="Previous solution"
            ></dx-button>
            <span class="readout">{{this.index + 1}} of {{this.count}}</span>
            <dx-button icon="chevronright"
                       [disabled]="this.index >= this.count - 1"
                       (onClick)="this.step(1)"
                       hint="Next solution"
            ></dx-button>
        </div>
    `,
    styles: [`
        .ooa-pager {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 4px 0;
        }

        .ooa-pager .readout {
            min-width: 52px;
            text-align: center;
            font-weight: bold;
        }
    `]
})
export class OoaSolutionPagerComponent {

    @Input() count = 0;

    @Input() index = 0;

    @Output() indexChange = new EventEmitter<number>();

    step(delta: number): void {
        const next = this.index + delta;

        if (next < 0 || next >= this.count) {
            return;
        }

        this.index = next;
        this.indexChange.emit(next);
    }
}
